import { render, staticRenderFns } from "./create-payment-dialog.vue?vue&type=template&id=c6ccaf4c&scoped=true&"
import script from "./create-payment-dialog.vue?vue&type=script&lang=js&"
export * from "./create-payment-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ccaf4c",
  null
  
)

export default component.exports